import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import FlexLink from '@components/FlexLink';
import TimeAgo from '@components/TimeAgo';
import UserProfileLink from '@components/User/UserProfileLink';
import { userName } from '@components/User/userHelpers';
import { forum_post_path } from '@routes';
import { ForumPost } from '@utils/backend-api/forumPosts';
import { stripHtml } from '@utils/formatting';

import ForumPostActions from '../ForumPostActions';
import ForumTags from '../ForumTags';
import styles from './styles.module.scss';

export default function ForumPostListItem({ forumPost }: { forumPost: ForumPost }) {
  const {
    comment: { user },
  } = forumPost;

  return (
    <div className={styles.forumPost} data-test="forum-post">
      <FlexLink href={forum_post_path(forumPost.id)} className={styles.forumPostHeading}>
        <div className={styles.forumPostTitle}>{forumPost.title}</div>
        <TimeAgo className={styles.forumPostDate} date={forumPost.created_at} />
      </FlexLink>
      <div className={styles.postedBy}>
        Posted by
        <UserProfileLink user={user} className={styles.userInfo}>
          {userName(user)}
          {!!user.company_name && (
            <>
              <div className={styles.userInfoSeparator} />
              <div>{user.company_name}</div>
            </>
          )}
        </UserProfileLink>
      </div>
      <FlexLink href={forum_post_path(forumPost.id)} className={styles.forumPostBody}>
        {ReactHtmlParser(stripHtml(forumPost.comment.snippet))}
      </FlexLink>
      <div className={styles.forumPostFooter}>
        <ForumTags tags={forumPost.entity_tags} small={true} />
        <ForumPostActions forumPost={forumPost} minimal={true} />
      </div>
    </div>
  );
}
